// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"468b4526","191":"0fd7ae49","239":"8af094c7","455":"43f320f1","977":"c7dc8da4"}[chunkId] + ".chunk.js";
};